/**
 * @module constants
 */

export default {
  SIDEBAR_WIDTH: '4.6rem',
  SIDEBAR_MIN_WIDTH: '2.75rem',
  FOOTER_HEIGHT: '5rem',
  TOP_BAR_HEIGHT: '1.8rem'
};



// WEBPACK FOOTER //
// ./app/constants/app.js